
const ShowcaseSection = () => {
    return (
      <section
        id="showcase"
        className="h-screen bg-blue-100 flex justify-center items-center"
      >
        <h1 className="text-4xl font-bold text-center">Showcase Section</h1>
      </section>
    );
  };

  export default ShowcaseSection;